
import React from 'react';
import { useTranslate } from 'react-admin';

const Legend = (props: LegendProps) => {
    const translate = useTranslate();
    const propClassName = props.className ? ` ${props.className}` : '';
    const className = `legendTitle${propClassName}`;
    return React.createElement(props.variant ? props.variant : "h2", { className }, translate(props.label || "resources.details"));
};

// what? TypeScript loses the displayName if we don't set it explicitly
Legend.displayName = 'Legend';

export interface LegendProps {
    label?: string,
    variant?: string,
    className?: string
};


export default Legend;